// Imports
import React from "react"
import { Header } from "fajny-react"
import { NavLink } from "react-router-dom"

import LayoutHeader from "../../components/LayoutHeader"

const DemoHeaderTransparentPrimary = () => {
    return (
        <LayoutHeader title="Header transparent primary">
            <Header headerStyle="transparent" color="primary" logoImg="/images/logo-fajny-css.svg" logoAlt="Logo" position="absolute">
                <NavLink to="#">Link</NavLink>
                <NavLink to="/">Link</NavLink>
                <NavLink to="/">Link</NavLink>
                <NavLink to="/">Link</NavLink>
            </Header>
        </LayoutHeader>
    )
}

export default DemoHeaderTransparentPrimary
